const initialState = {
  isError: false,
  isLoading: false,
  isSuccess: false,
};

export default initialState;
